import { DualListBoxItem } from '../../../../DualListBox';
import useStore from '../../../../Hooks/useStore';
import * as S from './Styles';

type SelectedItemMaskProps = FilteredProductItem & {
  hover?: boolean;
  selectedItems: DualListBoxItem[];
  markedSelectedItems: DualListBoxItem[];
};
const SelectedItemMask = ({
  hover = false,
  selectedItems,
  markedSelectedItems,
  identifier,
  ...product
}: SelectedItemMaskProps) => {
  const { ean, resume, code } = product;
  const [getters, setters] = useStore();
  const {
    form: { getForm },
  } = getters;
  const {
    form: { setForm },
  } = setters;
  const pinnedSingleForms = getForm('batchBanner.batch.pinnedSingleForms');
  const singleForms = getForm('batchBanner.singleForms');
  const showSingleFormId = getForm('batchBanner.showSingleFormId');
  const isPinned = pinnedSingleForms.includes(identifier);
  const isShowed = identifier === showSingleFormId;

  const showProduct = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    if (!isShowed) {
      setForm('batchBanner.showSingleFormId', identifier);
    }
    if (!isPinned) {
      if (pinnedSingleForms.length > 0) {
        setForm('batchBanner.batch.pinnedSingleForms', [
          identifier,
          ...pinnedSingleForms,
        ]);
      }
    }
  };

  const pinProduct = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setForm(
      'batchBanner.batch.pinnedSingleForms',
      isPinned
        ? pinnedSingleForms.filter((id) => id !== identifier)
        : [identifier, ...pinnedSingleForms],
    );

    if (!isPinned) {
      setForm('batchBanner.showSingleFormId', identifier);
    } else {
      setForm(
        'batchBanner.showSingleFormId',
        pinnedSingleForms.filter((id) => id !== identifier)[0] ?? identifier,
      );
    }
  };

  return (
    <S.SelectedItemMaskContainer pinned={isPinned} hover={hover}>
      <S.SelectedItemMaskLabel>
        {`${ean} - ${resume} - ${code}`}
      </S.SelectedItemMaskLabel>
      <S.SelectedItemMaskControlContainer>
        <S.SelectedItemMaskControl
          pinned={isShowed}
          hover={hover}
          onClick={showProduct}
          emptyList={isShowed}
        >
          <S.SelectedItemMaskControlIconEye pinned={isShowed} hover={hover} />
        </S.SelectedItemMaskControl>

        <S.SelectedItemMaskControl
          pinned={isPinned}
          hover={hover}
          onClick={pinProduct}
          emptyList={pinnedSingleForms.length === 0}
        >
          <S.SelectedItemMaskControlIconPin pinned={isPinned} hover={hover} />
        </S.SelectedItemMaskControl>
      </S.SelectedItemMaskControlContainer>
    </S.SelectedItemMaskContainer>
  );
};

export default SelectedItemMask;
